import axiosClient from "../../http-common";
import { USERS_BASE_URL } from "../../constants/routes/api";

class UsersApiService {
  getUser = async (userId) => {
    return axiosClient.get(`${USERS_BASE_URL}/${userId}`).then((res) => {
      return res.data;
    });
  };

  updateGlobalAdminRole = async (userId, newGlobalAdminRole) => {
    let body = {
      data: {
        role: newGlobalAdminRole ? "globalAdmin" : "none",
      },
    };

    return axiosClient.put(`${USERS_BASE_URL}/${userId}/role`, body);
  };

  addUser = async (user) => {
    let body = {
      data: user,
    };
    return axiosClient.post(`${USERS_BASE_URL}`, body);
  };

  getAllAccessibleTenantsByUserId = async (userId) => {
    return axiosClient.get(`${USERS_BASE_URL}/${userId}/tenants`);
  };

  getUserRole = async (userId) => {
    return axiosClient.get(`${USERS_BASE_URL}/${userId}/role`);
  };

  deleteUser = async (userId) => {
    return axiosClient.delete(`${USERS_BASE_URL}/${userId}`);
  };
}

export default new UsersApiService();
